import React from 'react';
import { Card, Skeleton } from 'antd';
import { Line } from '@ant-design/charts';

interface ConversationTrendChartProps {
    data: { date: string; count: number }[];
    loading?: boolean;
}

const ConversationTrendChart: React.FC<ConversationTrendChartProps> = ({ data, loading }) => {
    const config = {
        data,
        padding: 'auto',
        xField: 'date',
        yField: 'count',
        smooth: true,
        color: '#2563EB',
        areaStyle: {
            fill: 'l(270) 0:#ffffff 0.5:#d6e4ff 1:#2563EB',
        },
        meta: {
            count: {
                alias: '对话数量',
            },
        },
        tooltip: {
            showMarkers: true,
        },
        lineStyle: {
            lineWidth: 3,
        },
    };

    return (
        <Card
            title={<span style={{ fontWeight: 600 }}>近 7 天对话趋势</span>}
            variant="borderless"
            style={{ borderRadius: 12, height: '100%', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}
        >
            <Skeleton loading={loading} active paragraph={{ rows: 6 }}>
                <div style={{ height: 250 }}>
                    {data && data.length > 0 ? (
                        <Line {...(config as any)} />
                    ) : (
                        <div style={{ textAlign: 'center', color: '#A1A1AA', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>暂无趋势数据</div>
                    )}
                </div>
            </Skeleton>
        </Card>
    );
};

export default ConversationTrendChart;
